import React from 'react';
import { Link } from 'react-router-dom';

const PremiumRequiredScreen = () => {
  return (
    <div className="page analysis-page">
      <section className="hero-panel compact premium-preview-hero">
        <div className="hero-copy">
          <span className="hero-badge">Premium Kilidi</span>
          <h1>PREMIUM UYELIK GEREKIR</h1>
          <p>AI analizler sadece premium uyeler icin aciktir.</p>
        </div>
      </section>

      <div className="analysis-card premium-preview-card">
        <div className="analysis-header">
          <span>Premium Erisim</span>
          <span className="confidence high">Kilitli</span>
        </div>
        <p className="analysis-summary premium-preview-lead">
          AI analizler, marketler ve tahmin kartlari sadece premium uyelere gosterilir.
        </p>
        <div className="premium-live-lock premium-live-lock-blink analysis-lock-banner">
          PREMIUM UYELIK GEREKIR
        </div>
        <Link to="/premium-preview" className="btn-primary">
          Premium Uyelige Gec
        </Link>
      </div>
    </div>
  );
};

export default PremiumRequiredScreen;
